import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("OK");
      navigate("/login");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <p className="eyebrow">{t.auth.resetTitle}</p>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3 text-[#0B192C]">{t.auth.resetTitle}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="reset-form">
        <div>
          <label className="label-elegant">{t.auth.newPassword}</label>
          <input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-elegant" data-testid="reset-password" />
        </div>
        {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
        <button disabled={busy || !token} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="reset-submit">{t.auth.send}</button>
      </form>
      <p className="mt-6 text-sm text-slate-500"><Link to="/login" className="underline underline-offset-4">{t.auth.signIn}</Link></p>
    </div>
  );
}
